<template>
  <div class="events-component">
    <div class="row">
      <div class="filter--events col-md-3">
        <div class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('filter') }}</label>
          <div class="list-group">
            <a @click="selectFilter(option.id)" v-for="option in formOptions"
               class="list-group-item list-group-item-action" :class="{'active' : filterForm.filter === option.id}"
               href="javascript:void(0)">
              {{ option.title }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="row">
          <div v-if="app.type && app.type.id !== APP_TYPE_DEMO" class="event-dispatch-stats col-4">
            <div v-if="notDispatchedCount > 0" class="event-dispatch-item">
              <div class="event-dispatch-item--num">{{ notDispatchedCount }}</div>
              {{ getTranslation('notDispatchedCandidates') }}
            </div>
            <div v-else-if="retakesCount > 0" class="event-dispatch-item event-dispatch-retake-item">
              <div class="event-dispatch-item--num event-dispatch-retake-item--num">{{ retakesCount }}</div>
              {{ getTranslation('notDispatchedForRetake') }}
            </div>
          </div>
          <div class="col-8">
            <div class="section__controls">
              <div class="section__controls-group">
                <button v-if="hasPermission('api.application.profile.createEvent')" class="btn btn--main btn--sm"
                        @click="addEvent">
                  + {{ getTranslation('addEvent') }}
                </button>
                <button class="btn  btn--info-outline btn--sm" @click="toggleCalendarView">
                  {{ getTranslation('eventCalendarView') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <table v-if="items.length > 0" class="table  table--noborder mt-4 table-zebra">
          <thead class="table__head">
          <tr class="table__row">
            <th class="table__cell  table__hcell" style="width:3%">#</th>
            <th class="table__cell  table__hcell" style="width:10%">{{ getTranslation('affiliate') }} - {{ items.length }}</th>
            <th class="table__cell  table__hcell" style="width:5%">{{ getTranslation('candidateCount') }}</th>
            <th class="table__cell  table__hcell" style="width:5%">{{ getTranslation('availableCount') }}</th>
            <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('dateAndTime') }}</th>
            <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('status') }}</th>
            <th class="table__cell  table__hcell" style="width: 0.2%;"></th>
          </tr>
          </thead>
          <tbody class="table__body">
          <tr v-for="item in items" v-bind:key="item.id" class="table__row">
            <td class="table__cell event--item-td">
              {{ item.id }}
            </td>
            <td class="table__cell event--item-td">
              <router-link :to="{name:'api.office.get',params:{id:item.office.id}}">{{ item.office.title }}
              </router-link>
            </td>

            <td class="table__cell event--item-td" :class="{'text--bold ':item.retakeCount > 0}">{{ item.candidateCount }}</td>
            <td class="table__cell event--item-td">{{ item.availableCount }}</td>
            <td class="table__cell event--item-td" v-if="app.type && app.type.id !== APP_TYPE_DEMO">{{ momentFormatDate(item.startTime, 'HH:mm') }} -
              {{ momentFormatDate(item.endTime, 'HH:mm') }}, {{ momentFormatDate(item.endTime, 'DD.MM.YYYY') }}
            </td>
            <td class="table__cell event--item-td" v-else>
              {{ momentFormatDate(item.startTime, 'DD.MM.YYYY') }} - {{ momentFormatDate(item.endTime, 'DD.MM.YYYY') }}
            </td>

            <td class="table__cell event--item-td">

              <div v-if="item.eventStatus === 'EVENT_FAILED'" class="mytooltip-wrapper" style="display: inline-block">
                                                   <span class="badge badge--accent">
                                                       {{ getTranslation('EVENT_FAILED') }}
                                                   </span>
                <div class="mytooltip  mytooltip--dark  mytooltip--bottom-right" style="right:0">
                  <div class="mytooltip__arrow"></div>
                  <div class="mytooltip__header  pb-0">
                    <div class="mytooltip__header-inner">
                      <h4 class="mytooltip__title  mytooltip__title--light">
                        {{ getTranslation('eventRejectComment') }}
                      </h4>
                      <div class="mytooltip__controls" v-if="hasPermission('api.testing.event.get')">
                        <router-link :to="{ name: 'api.testing.event.get', params: { id:item.id} }"
                                     class="btn btn--sm btn--link">{{ getTranslation('moreInfo') }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="mytooltip__body">
                    <p> {{ item.comment }}</p>
                  </div>
                </div>
              </div>

              <span v-else-if="item.isFuture" :class="{'badge badge--warning':item.retakeCount > 0}">{{ getTranslation('testing_future') }}</span>
              <span v-else-if="item.isPassed" :class="{'badge badge--warning':item.retakeCount > 0}">{{ getTranslation('testing_past') }}</span>
              <span v-else-if="item.isActive" :class="{'badge badge--warning':item.retakeCount > 0}">{{ getTranslation('testing_active') }}</span>

            </td>
            <td class="table__cell event--item-td">
              <ActionsComponent
                  :options="{
                      cancelEvent:allowAppAction(app,item,'api.testing.event.profile.reject'),
                      registrationList:allowAppAction(app,item,'api.application.profile.registrationList'),
                      tokenList:allowAppAction(app,item,'api.application.profile.generateTokenList'),
                      viewPage:app.status==='CONFIRMED' && hasPermission('api.testing.event.get')
                    }"
                  :has-edit="allowAppAction(app,item,'api.application.profile.editEvent',true)"
                  :has-delete="allowAppAction(app,item,'api.testing.event.delete',true)"
                  v-on:cancelEvent="cancelTestingEvent(item.id)"
                  v-on:edit="editEvent(item)"
                  v-on:delete="deleteEvent(item.id)"
                  v-on:registrationList="registrationList(item.id,$event)"
                  v-on:tokenList="tokenList(item.id,$event)"
                  v-on:viewPage="()=>{$router.push({name:'api.testing.event.get',params:{id:item.id}})}"
              />
            </td>
          </tr>
          </tbody>
        </table>
        <table v-else class="table  table--noborder">
          <tr class="table__row">
            <td class="table__cell empty">
              {{ getTranslation('notAddedYet') }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- modal event -->
    <modal
        v-model="showModal"
        :modal-title="edit ? getTranslation('edit') : getTranslation('add')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="saveTestingEvent"
        @cancelButtonClick="resetModal"
        @input="resetModal"
    >
      <form class="event-form w-100">
        <span class="text-danger">* {{ getTranslation('required') }}</span>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('office') }}<span class="required">*</span></label>
          <v-select
              :options="offices"
              :reduce="option=>option.id"
              label="title"
              :placeholder="getTranslation('selectFromList')"
              v-model="eventForm.officeId"
              :class="{'field--error': $v.eventForm.officeId.$error}"
          />
          <div v-if="$v.eventForm.officeId.$error" class="form__error">{{ getTranslation('requiredField') }}<span
              class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label  form__label--block"> {{ getTranslation('dateAndTime') }}<span
              class="required">*</span></label>

          <div class="form__tillfrom-row">
            <div>
              <DatePicker
                  v-model="eventForm.startTime"
                  :pick-time="app.type && app.type.id !== APP_TYPE_DEMO"
                  :format="app.type && app.type.id!== APP_TYPE_DEMO ? 'YYYY-MM-DD Hh:mm':'YYYY-MM-DD'"
                  :display-format="app.type && app.type.id !== APP_TYPE_DEMO ? 'DD.MM.YYYY Hh:mm':'DD.MM.YYYY'"
                  :placeholder="app.type && app.type.id !== APP_TYPE_DEMO ? 'дд.мм.гг чч:мм':'дд.мм.гг'"
              />
              <div v-if=" $v.eventForm.startTime.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
            </div>
            <div class="form__tillfrom-sep"></div>

            <div>
              <DatePicker
                  :editable="app.type && app.type.id === APP_TYPE_DEMO"
                  v-model="eventForm.endTime"
                  :pick-time="app.type && app.type.id !== APP_TYPE_DEMO"
                  :format="app.type && app.type.id!== APP_TYPE_DEMO ? 'YYYY-MM-DD Hh:mm':'YYYY-MM-DD'"
                  :display-format="app.type && app.type.id !== APP_TYPE_DEMO ? 'DD.MM.YYYY Hh:mm':'DD.MM.YYYY'"
                  :placeholder="app.type && app.type.id !== APP_TYPE_DEMO ? 'дд.мм.гг чч:мм':'дд.мм.гг'"
              />
              <div v-if=" $v.eventForm.endTime.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
            </div>
          </div>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import testingEventsMixin from "../../events/mixin/testingEvents";
import testActionsMixin from "../../events/mixin/testingEventAction";
import reportMixin from "@/views/admin/reports/mixins/report";

export default {
  name: "EventsComponent",
  mixins: [testingEventsMixin, testActionsMixin, reportMixin],
  props: ['appId', 'active', 'app'],
  data() {
    return {
      showModal: false,
      edit: false,
      comment: '',
      eventForm: {
        id: '',
        officeId: '',
        startTime: '',
        endTime: '',
      },
      formOptions: [],
      filterForm: {
        filter: '',
      }
    }
  },
  created() {
    if (this.active) {
      this.fetchEventFormOptions().then(response => {
        this.formOptions = response;
        this.eventTiming();
        this.fetchAppEvents(this.appId, false, this.filterForm);
      });
    }
  },
  watch: {
    active(val) {
      if (val)
        this.fetchEventFormOptions().then(response => {
          this.formOptions = response;
          this.fetchAppEvents(this.appId, false, this.filterForm);
        });
    },

    'eventForm.startTime'(val) {
      if (this.structureDuration && val) {

        if (this.app.type.id !== this.APP_TYPE_DEMO)
          this.eventForm.endTime = this.$moment(val, 'YYYY-MM-DD HH:mm').add(this.structureDuration, 'minutes').format('YYYY-MM-DD HH:mm');
        else
          this.eventForm.endTime = this.$moment(val, 'YYYY-MM-DD').add(10, 'days').format('YYYY-MM-DD');
      }
    }
  },
  methods: {
    tokenList(eventId, format = this.formats.word) {

      let isPdf = format === this.formats.pdf;

      let responseType = 'json';

      if (!isPdf)
        responseType = 'blob';

      this.axios.get(this.$config.urls.event.generateTokenList.url.replace(':id', eventId), {
        responseType: responseType,
        params: {format: format}
      })
          .then(response => {
            let url = '';

            if (isPdf)
              url = response.data.data.file;
            else
              url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Пароли ' + this.$moment().format('YYYY-MM-DD HH-mm') + format);
            document.body.appendChild(link);
            link.click();
          }).catch(() => {
      });
    },
    registrationList(eventId, format = this.formats.word) {

      let isPdf = format === this.formats.pdf;

      let responseType = 'json';

      if (!isPdf)
        responseType = 'blob';

      this.axios.get(this.$config.urls.event.downloadRegistrationList.url.replace(':id', eventId), {
        responseType: responseType,
        params: {format: format}
      })
          .then(response => {
            let url = '';

            if (isPdf)
              url = response.data.data.file;
            else
              url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.getTranslation('registrationList') + this.$moment().format('YYYY-MM-DD HH:mm') + format);
            document.body.appendChild(link);
            link.click();
          }).catch(() => {
      });
    },
    allowAppAction(app, item, permission, isNew = false) {

      let appStatus = 'CONFIRMED';

      if (app.status === appStatus) {

        if (permission === 'api.testing.event.profile.reject')
          return true;

        if (item.isPassed)
          return false;

      }

      if (isNew)
        appStatus = 'NEW';

      return app.status === appStatus && item.eventStatus === 'EVENT_SUCCESS' && this.hasPermission(permission)
    },

    async cancelTestingEvent(eventId) {
      this.comment = await Swal.fire({
        title: '<label class="form__label reject--comment-label">' + this.getTranslation('eventRejectComment') + '<span class="required">*</span></label>',
        input: 'textarea',
        inputPlaceholder: this.getTranslation('writeEventRejectComment'),
        inputValidator: (value) => {
          if (!value) {
            return this.getTranslation('writeEventRejectComment');
          }
        },
        showCancelButton: true,
        cancelButtonText: this.getTranslation('cancel')
      });

      if (this.comment.value) {

        this.rejectEvent(eventId, {comment: this.comment.value}).then(() => {

          this.fetchAppEvents(this.appId, false, this.filterForm);

          this.$root.$emit('eventReject');

          Swal.fire(
              this.getTranslation('cancelled'),
              this.getTranslation('eventCancelledMsg'),
              'success'
          );

        }).catch(() => {
        });
      }
    },

    selectFilter(filter) {
      this.filterForm.filter = filter;
      this.fetchAppEvents(this.appId, false, {filter: filter});
    },

    addEvent() {
      this.edit = false;
      this.eventTiming();
      this.showModal = true;
    },

    editEvent(item) {

      this.$v.$reset();
      this.edit = true;

      this.eventForm.id = item.id;
      this.eventForm.endTime = item.endTime;
      this.eventForm.startTime = item.startTime;
      this.eventForm.officeId = item.office.id;
      this.showModal = true;

    },

    deleteEvent(id) {
      this.$snotify.confirm(this.getTranslation('deleteConfirmMsg'), {
        showProgressBar: false,
        closeOnClick: false,
        backdrop: 0.5,
        buttons: [
          {
            text: this.getTranslation('yes'), action: (toast) => {
              this.axios.delete(this.$config.urls.event.fetchEvent.url.replace(':id', id))
                  .then(() => {
                    this.fetchAppEvents(this.appId, false, this.filterForm);
                    this.$snotify.remove(toast.id);
                    setTimeout(() => {
                      this.snotifySuccess('deleteSuccessMsg');
                    });
                  }).catch(() => {
                this.snotifyError('serverError');
              });
            }, bold: true
          },
          {text: this.getTranslation('no'), action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },

    saveTestingEvent() {

      this.$v.eventForm.$touch();
      if (this.$v.eventForm.$invalid)
        return this.snotifyError('wrongFormMsg');

      this.saveAppEvent(this.appId, this.eventForm.id)
          .then(() => {
            this.resetModal();
            this.fetchAppEvents(this.appId, false, this.filterForm);
          }).catch(() => {
      })
    },

    resetModal() {
      this.showModal = false;
      this.eventForm = {
        id: '',
        officeId: '',
        startTime: this.$moment().add(7, 'days').hours(9).minutes(5).format('YYYY-MM-DD HH:mm'),
        endTime: this.$moment().add(7, 'days').hours(11).minutes(30).format('YYYY-MM-DD HH:mm'),
      };

      this.$v.$reset();
    },
  },
  validations: {
    eventForm: {
      officeId: {
        required
      },
      startTime: {
        required
      },
      endTime: {
        required
      }
    }
  }
}
</script>

<style scoped>
.event-form {
  min-width: 500px;
  margin-bottom: 50px;
}

.filter--events {
  max-width: 200px;
  border-right: 1px solid #DEEAFF;
}

.event--item-td {
  vertical-align: middle !important;
}
</style>
